document.addEventListener('DOMContentLoaded', function() {
  function checkIfAtBottom() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    // Check if we're within 50px of the bottom
    const isAtBottom = scrollTop + windowHeight >= documentHeight - 50;
    
    if (isAtBottom) {
      document.body.classList.add('mk-bottom');
    } else {
      document.body.classList.remove('mk-bottom');
    }
  }

  // Check on scroll
  window.addEventListener('scroll', checkIfAtBottom, { passive: true });
  
  // Check on page load
  checkIfAtBottom();
  
  // Check on resize
  window.addEventListener('resize', checkIfAtBottom, { passive: true });
});
